module.exports = "<template>\n    <div innerhtml.bind=\"config.content | t\"></div>\n</template>\n";